const stepMap = {
  NAME: 0,
  "KNOWS_THE_DOCTORS": 1,
  "TREATING-DOC": 2,
  "EXISTING-PATIENT": 3,
  "TREATING-LOC": 4,
  "PREF-TREATING-LOC": 5,
  PID: 6,
  DOB: 7,
  GENDER: 8,
  MOBILE: 9,
  "MOBILE-VERIFY": 10,
  EMAIL: 11,
  RESIDENCE: 12,
  TERMS: 13,
  CONGRATS: 14,
};

export default stepMap;
